const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const moment = require("moment");

const AT = require("../core/vault/ActionTypes");

const LoadableButton = require("../office/LoadableButton");

const OfficeModal = require("../office/modals/OfficeModal");
const CopyTable = require("./data/CopyTable");
const SchoolUtil = require("../../shared/SchoolUtil");

const styles = require("./styles/AddSeats.css");

// Date after which IPL accounts show the new contract language
const IPL_NEW_CONTRACT_DATE = moment.utc("2026-01-01");

const {atSchoolAccountPurchase} = require("../core/vault/StateCursors");
const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const purchaseInfo = atSchoolAccountPurchase(vaultState).get();
			return {
				purchase: purchaseInfo,
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

const AddSeats = createReactClass({
	displayName: "AddSeats",

	propTypes: {
		purchaseInfo: PT.object.isRequired,

		// Injected by HOCs
		dispatch: PT.func.isRequired,
	},

	vaultEvents: {
		addSeatsSuccess: function(response) {
			this.setState({
				isLoading: false,
				modal: "success",
				response,
				// reset the modal to the initial values
				quantity: 5,
				comments: "",
				confirmation: false,
			});
		},
		addSeatsFailure: function(response) {
			this.setState({isLoading: false, modal: "failure", response});
		},
	},

	getInitialState: function() {
		return {
			modal: null,
			quantity: 5,
			comments: "",
			confirmation: false,
			isLoading: false,
			response: false,
		};
	},

	openModal: function() {
		const canRequestSeats = SchoolUtil.canRequestSeats(this.props.purchaseInfo);
		if (canRequestSeats) {
			this.setState({modal: "main"});
		} else {
			this.setState({modal: "noaccess"});
		}
	},

	closeModal: function() {
		if (!this.state.isLoading) {
			this.setState({modal: null, confirmation: false});
		}
	},

	renderButton: function() {
		return (
			<div className={styles.editLimitButton} onClick={this.openModal}>
				{CopyTable.getAddSeatsCopy("button")}
			</div>
		);
	},

	onCommentsChange: function(ev) {
		this.setState({comments: ev.target.value});
	},

	onConfirmationChange: function(ev) {
		this.setState({confirmation: ev.target.checked});
	},

	onQuantityChange: function(ev) {
		const quantity = Math.floor(Number(ev.target.value.replace(/[^0-9]/g, "")));
		if (ev.target.value) {
			ev.target.value = quantity;
		}
		this.setState({quantity});
	},

	onNext: function() {
		this.setState({modal: "continue"});
	},

	onBack: function() {
		this.setState({modal: "main"});
	},

	onSubmit: function() {
		const purchaseID = this.props.purchaseInfo.id;
		const {quantity, comments, confirmation} = this.state;
		this.props.dispatch({
			type: AT.ADD_SEATS_REQUEST,
			purchaseID,
			quantity,
			comments,
			confirmation,
		});
		this.setState({isLoading: true});
	},

	renderButtons: function(buttons) {
		if (!buttons || !buttons.length) {
			return null;
		}
		return (
			<div className={styles.buttonRow}>
				{buttons.map((button, i) => {
					const buttonStyles = [styles.button];
					if (button.disabled) {
						buttonStyles.push(styles.buttonDisabled);
					}
					const onButtonClick = {
						close: this.closeModal,
						back: this.onBack,
						next: this.onNext,
						submit: this.onSubmit,
					}[button.func];
					if (button.canLoad) {
						return (
							<LoadableButton
								key={i}
								buttonText={button.text}
								status={button.loading ? "loading" : "none"}
								className={buttonStyles.join(" ")}
								onClick={onButtonClick}
							/>
						);
					}
					return (
						<div
							key={i}
							className={buttonStyles.join(" ")}
							onClick={onButtonClick}
						>
							{button.text}
						</div>
					);
				})}
			</div>
		);
	},

	renderField: function(options) {
		const {label, vertical, content} = options;
		const containerStyles = [styles.labeledValue];
		if (vertical) {
			containerStyles.push(styles.vertical);
		}
		return (
			<div className={containerStyles.join(" ")}>
				<div className={styles.label}>{label?.toUpperCase() + ": "}</div>
				{content}
			</div>
		);
	},

	getMainModalCopy: function() {
		return {
			title: CopyTable.getAddSeatsCopy("title"),
			content: (
				<>
					<div className={styles.instructions}>
						{CopyTable.getAddSeatsCopy("top")}
					</div>
					{this.renderField({
						label: CopyTable.getAddSeatsCopy("label.quantity"),
						content: (
							<div>
								<input
									className={styles.input + " " + styles.numberInput}
									type="text"
									defaultValue={this.state.quantity}
									onInput={this.onQuantityChange}
									min="1"
									step="1"
								/>{" "}
								student seats
							</div>
						),
					})}
					{// TODO: change the minimum to 1 after version 2 of this feature
					//       when the customer can pay directly.
					this.state.quantity < 5 ? (
						<div className={styles.inputError}>
							A minimum of 5 seats must be ordered
						</div>
					) : null}
					{this.state.quantity > 1000 ? (
						<div className={styles.inputError}>
							A maximum of 1000 seats can be ordered
						</div>
					) : null}
					{this.renderField({
						label: CopyTable.getAddSeatsCopy("label.comments"),
						content: (
							<textarea
								className={styles.input + " " + styles.textarea}
								onChange={this.onCommentsChange}
								defaultValue={this.state.comments}
							/>
						),
						vertical: true,
					})}
					{this.state.comments.length > 1000 ? (
						<div className={styles.inputError}>
							Comments cannot exceed 1000 characters.
						</div>
					) : null}
				</>
			),
			buttons: [
				{
					text: CopyTable.getAddSeatsCopy("cancel"),
					func: "close",
					disabled: this.state.isLoading,
				},
				{
					text: CopyTable.getAddSeatsCopy("next"),
					func: "next",
					disabled:
						this.state.quantity < 5 ||
						this.state.quantity > 1000 ||
						this.state.comments.length > 1000,
				},
			],
		};
	},

	getContinueModalCopy: function() {
		const isIplManaged = !this.props.purchaseInfo?.isAopsManaged;

		// Check if this IPL account started or renewed since Jan 1, 2026
		const {subscriptionStartDate, lastRenewalStartDate} =
			this.props.purchaseInfo || {};
		const subscriptionStartMoment = subscriptionStartDate
			? moment.utc(subscriptionStartDate)
			: null;
		const lastRenewalMoment = lastRenewalStartDate
			? moment.utc(lastRenewalStartDate)
			: null;
		const isIplNewContract =
			isIplManaged &&
			((subscriptionStartMoment &&
				subscriptionStartMoment.isSameOrAfter(IPL_NEW_CONTRACT_DATE)) ||
				(lastRenewalMoment &&
					lastRenewalMoment.isSameOrAfter(IPL_NEW_CONTRACT_DATE)));

		// Different disclaimer text for IPL accounts based on contract date
		let iplDisclaimer = null;
		if (isIplNewContract) {
			iplDisclaimer = (
				<div className={styles.iplDisclaimer}>
					Your seat increase is governed by your Content Services and License
					Agreement with Inflection Point Learning, Inc. You will receive an
					invoice for the additional seats. If you have any questions, please
					contact schools@inflectionpointlearning.com.
				</div>
			);
		}

		return {
			title: "Confirm Your Order",
			content: (
				<>
					<div>
						<strong>{this.state.quantity} new student seats</strong> will be
						added to your account.
					</div>
					{iplDisclaimer}
					<div>
						<label className={styles.confirmationContainer}>
							<input
								type="checkbox"
								className={styles.confirmationCheckbox}
								onChange={this.onConfirmationChange}
								defaultChecked={this.state.confirmation}
							/>
							{CopyTable.getAddSeatsCopy("confirmation")}
						</label>
					</div>
				</>
			),
			buttons: [
				{text: "Back", func: "back"},
				{
					text: CopyTable.getAddSeatsCopy("submit"),
					func: "submit",
					loading: this.state.isLoading,
					// TODO: change the minimum to 1 after version 2 of this feature
					//       when the customer can pay directly.
					disabled:
						this.state.quantity < 5 ||
						this.state.quantity > 1000 ||
						!this.state.confirmation,
					canLoad: true,
				},
			],
		};
	},

	renderModal: function() {
		const modalType = this.state.modal;
		let modalCopy = null;
		if (modalType === "main") {
			modalCopy = this.getMainModalCopy();
		} else if (modalType === "continue") {
			modalCopy = this.getContinueModalCopy();
		} else if (["success", "failure", "noaccess"].includes(modalType)) {
			modalCopy = CopyTable.getAddSeatsModalCopy(modalType, this.state);
		} else {
			return null;
		}
		const {title, content, buttons = []} = modalCopy;
		return (
			<OfficeModal
				onClose={this.closeModal}
				level="overBar"
				portalContainer={null}
				closeOnEsc={true}
				modalClass={styles.modal}
				backdropClass={styles.backdrop}
			>
				<div className={styles.title}>{title}</div>
				<div className={styles.modalText}>{content}</div>
				{this.renderButtons(buttons)}
			</OfficeModal>
		);
	},

	render: function() {
		return (
			<div>
				{this.renderButton()}
				{this.renderModal()}
			</div>
		);
	},
});

module.exports = augment(AddSeats);
